import React from "react";

function Header() {
  return (
    <div style={{ textAlign: "center", textTransform: "uppercase" }}>
      <h3>University of Nigeria Nsukka</h3>
      <h2>Faculty of Pharmaceutical Sciences</h2>
    </div>
  );
}

export default Header;
